export const MEMORY_GAME_TIME_LIMIT_SECONDS = 180;
export const MEMORY_GAME_QUESTION_COUNT = 15;
